import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ChartsModalContainer, type ChartsModalProps,
} from './chartsVisualizer.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ChartsDetails: ChartsModalProps;
  }
}
modalRenderer.register('ChartsDetails', ChartsModalContainer);
